import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const BotApi = createApi({
  reducerPath: "BotApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["BOTAPI"],
  endpoints: (build) => ({
    getAllBots: build.query({
      query: ({ page = 1, search = "", limit = 10 }) => ({
        url: `/bots?page=${page}&search=${search}&limit=${limit}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOTAPI"],
    }),

    getBotById: build.query({
      query: (id) => ({
        url: `/bots/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOTAPI"],
    }),

    getBotAnalytics: build.query({
      query: (id) => ({
        url: `/bots/${id}/analytics`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOTAPI"],
    }),

    createBot: build.mutation({
      query: (data) => ({
        url: `/bots`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOTAPI"],
    }),

    updateBot: build.mutation({
      query: ({ id, data }) => ({
        url: `/bots/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOTAPI"],
    }),

    toggleBotStatus: build.mutation({
      query: (id) => ({
        url: `/bots/${id}/status`,
        method: "PATCH",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOTAPI"],
    }),

    deleteBot: build.mutation({
      query: (id) => ({
        url: `/bots/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOTAPI"],
    }),

    processBotTrigger: build.mutation({
      query: (data) => ({
        url: `/bots/process`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
    }),
  }),
});

export const {
  useGetAllBotsQuery,
  useGetBotByIdQuery,
  useGetBotAnalyticsQuery,
  useCreateBotMutation,
  useUpdateBotMutation,
  useToggleBotStatusMutation,
  useDeleteBotMutation,
  useProcessBotTriggerMutation,
  useLazyGetAllBotsQuery,
  useLazyGetBotByIdQuery,
  useLazyGetBotAnalyticsQuery,
} = BotApi;